module.exports = __webpack_public_path__ + "img/31.98986c02.png";